/**
    companyName: '',
    siteName: '',
    ledgerName: '',
    businessType: '',
    feeTaskType: '',
    noTaxAmount: '',
    amount: '',
    remark: '',
    taxAmount: '',
    supplierComfirmAmount: ''
 *
 */
export default class DeliverClass {
    constructor({ companyName, siteName, ledgerName, businessType, feeTaskType, amount, taxAmount, remark, supplierComfirmAmount, noTaxAmount }) {
        this.companyName = companyName || '';
        this.siteName = siteName || '';
        this.ledgerName = ledgerName || '';
        this.businessType = businessType || '';
        this.feeTaskType = feeTaskType || '';
        this.amount = (amount + '') || '';
        this.taxAmount = (taxAmount + '') || '';
        this.remark = remark || '';
        this.noTaxAmount = noTaxAmount || '';
        this.supplierComfirmAmount = supplierComfirmAmount || '';
        if (this.taxAmount === 'undefined') {
            this.taxAmount = '';
        }
    }
}

export function initOrgonaztion(data) {
    return new DeliverClass(data);
}